import React from "react";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import { useNotification } from "../context/NotificationContext";

const FullAdminDashboard = ({ user, events, onLogout }) => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useNotification();

  if (user && user.role === "client" && !user.isApproved) {
    return (
      <div className="container py-5 text-center" dir="rtl">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="card shadow-lg border-0 p-4 p-md-5 rounded-celebration bg-white mx-2"
        >
          <div className="display-1 text-warning mb-4 animate-bounce">⚠️</div>
          <h2 className="fw-black mb-3 display-4 text-primary" style={{ fontFamily: 'var(--font-headline)' }}>حسابك لسه متفعلش!</h2>
          <p className="text-on-surface-variant fs-4 mb-5 px-md-5 arabic-leading">
            عشان تبدأ تعمل مناسبات وتستخدم لوحة التحكم، لازم الأدمن يفعل حسابك
            الأول بعد التأكد من الدفع وتأكيد البيانات.
          </p>
          <div className="bg-surface-variant p-4 p-md-5 rounded-4 shadow-sm d-inline-block text-end border-primary border-top border-4">
            <h4 className="fw-black mb-4 text-primary" style={{ fontFamily: 'var(--font-headline)' }}>
              تواصل مع الإدارة للتفعيل السريع:
            </h4>
            <p className="mb-3 fs-5">
              💬 <strong>واتساب:</strong>{" "}
              <a
                href="https://wa.me/201013201998"
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none"
              >
                01013201998
              </a>
            </p>
            <p className="mb-0 fs-5">
              📧 <strong>إيميل:</strong>{" "}
              <a
                href="mailto:youmak.egp@gmail.com"
                className="text-decoration-none"
              >
                youmak.egp@gmail.com
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="admin-layout" dir="rtl">
      {/* Header */}
      <header className="admin-header d-flex align-items-center justify-content-between px-3 px-md-4">
        <div className="d-flex align-items-center gap-3 gap-md-4 overflow-hidden">
          <h1
            className="text-xl text-md-2xl font-black text-primary tracking-tighter mb-0 cursor-pointer flex-shrink-0"
            style={{ fontFamily: 'var(--font-headline)', cursor: 'pointer' }}
            onClick={() => navigate("/")}
          >
            يومك
          </h1>
          <nav className="d-flex align-items-center gap-1 gap-md-3 overflow-x-auto text-nowrap hide-scrollbar pb-1 pb-md-0">
            {user.role === 'admin' ? (
              <>
                <button
                  className={`btn btn-link text-decoration-none fw-bold text-xs text-md-sm p-2 rounded-3 transition-soft border-0 ${!eventId && window.location.pathname === '/admin' ? 'text-primary bg-primary-dim' : 'text-muted hover:bg-light'}`}
                  onClick={() => navigate("/admin")}
                >
                  الرئيسية
                </button>
                <button
                  className={`btn btn-link text-decoration-none fw-bold text-xs text-md-sm p-2 rounded-3 transition-soft border-0 ${window.location.pathname.startsWith('/admin/users') ? 'text-primary bg-primary-dim' : 'text-muted hover:bg-light'}`}
                  onClick={() => navigate("/admin/users")}
                >
                  المشتركين والنظام
                </button>
                <button
                  className={`btn btn-link text-decoration-none fw-bold text-xs text-md-sm p-2 rounded-3 transition-soft border-0 ${window.location.pathname.startsWith('/admin/calendar') ? 'text-primary bg-primary-dim' : 'text-muted hover:bg-light'}`}
                  onClick={() => navigate("/admin/calendar")}
                >
                  التقويم
                </button>
              </>
            ) : (
              <>
                <button
                  className={`btn btn-link text-decoration-none fw-bold text-xs text-md-sm p-2 rounded-3 transition-soft border-0 ${!eventId && window.location.pathname === '/client' ? 'text-primary bg-primary-dim' : 'text-muted hover:bg-light'}`}
                  onClick={() => navigate("/client")}
                >
                  الرئيسية
                </button>
                <button
                  className={`btn btn-link text-decoration-none fw-bold text-xs text-md-sm p-2 rounded-3 transition-soft border-0 ${window.location.pathname.startsWith('/client/event') ? 'text-primary bg-primary-dim' : 'text-muted hover:bg-light'}`}
                  onClick={() => navigate("/client")}
                >
                  المناسبات
                </button>
              </>
            )}
          </nav>
        </div>
        <div className="d-flex align-items-center gap-3">
          <button className="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center border-0">
            <span className="material-symbols-outlined fs-5">notifications</span>
          </button>
          <div
            className="user-avatar bg-primary-dim rounded-circle overflow-hidden border-2 border-white shadow-sm d-flex align-items-center justify-content-center cursor-pointer"
            style={{ width: '40px', height: '40px', cursor: 'pointer' }}
            onClick={onLogout}
            title="تسجيل الخروج"
          >
             <span className="material-symbols-outlined text-primary fs-5">logout</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="admin-main bg-background min-vh-100">
        <div className="p-3 p-md-5 max-w-6xl mx-auto space-y-4 space-md-5">
           <Outlet />
        </div>
      </main>
    </div>
  );
};

export default FullAdminDashboard;
